import React from "react";
import PropTypes from "prop-types";
import { FutureTasksTemplate } from 'themes/application/dashboard/components';

class FutureTasks extends React.Component {
    render() {
        return <FutureTasksTemplate {...this.props} />;
    }
}

FutureTasks.propTypes = {
    title: PropTypes.string,
    onChange: PropTypes.func,
    data: PropTypes.object
};

export default FutureTasks;
